// 客户经理与终端用户通用接口
import request from "@/utils/request";
// 欣能汇接口
import requestForXnh from "@/utils/requestForXnh";

// -------------------------- 欣能汇接口 -----------------------------------
// 号码列表查询
export function xnhPhoneList(params) {
  return requestForXnh({
    url: "/api/product/fourhundredtel/listsimple",
    method: "post",
    params: params
  });
}

// -------------------------- 客户经理接口 -----------------------------------
// 获取微信相关签名
export function wxGetSign(params) {
  return request({
    url: "/wxauth/getwxShareSign",
    method: "get",
    params: params,
    metaValue: "获取微信相关签名",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// 微信支付
export function wxPay(params) {
  return request({
    url: "/wxauth/wxPay/native/pay",
    method: "post",
    params: params,
    metaValue: "微信支付",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// 获取支付签名
export function getPaySign(params) {
  return request({
    url: "/wxauth/getwxPaySignNew",
    method: "get",
    params: params,
    metaValue: "获取支付签名",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// 获取用户open-id
export function getOpenId(params) {
  return request({
    url: "/wxauth/wxAuthSnsapi_base",
    method: "get",
    params: params,
    metaValue: "获取用户open-id",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// 获取游客信息
export function getuserCustomer(params) {
  return request({
    url: "/customer/getYouKeInfo",
    method: "get",
    params: params,
    metaValue: "获取游客信息"
  });
}

// 微信支付2
export function wxPayTwo(params) {
  return request({
    url: "/wxauth/wxPay/jsapipay",
    method: "post",
    params: params,
    metaValue: "微信支付2",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// 联系客服
export function getServer(params) {
  return request({
    url: "/customer/getsysuserInfo",
    method: "get",
    params: params,
    metaValue: "联系客服"
  });
}

// 登录手机验证码获取
export function sendSmsCode(params) {
  return request({
    url: "/customer/smsnoticeLogin",
    method: "post",
    params: params,
    metaValue: "smsnoticeLogin"
  });
}

// 注册时手机验证码获取
export function sendSmsCodeForRegister(params) {
  return request({
    url: "/customer/smsnotice",
    method: "post",
    params: params,
    metaValue: "sendCode"
  });
}

// 登录
export function loginRegister(params) {
  return request({
    url: "/customer/loginTo",
    method: "post",
    params: params,
    metaValue: "登录"
  });
}

// 注册
export function onlyRegister(params) {
  return request({
    url: "/customer/register",
    method: "post",
    params: params,
    metaValue: "注册"
  });
}

// 文件上传
export function upFileApi(params) {
  return request({
    url: "/tools/btachUpload",
    method: "post",
    data: params,
    timeout: 600000,
    metaValue: "上传文件"
  });
}

// 文件下载
export function fileDownload(params) {
  return request({
    url: "/tools/wxauth/download/resource",
    method: "get",
    params: params,
    responseType: "blob",
    headers: { "Content-Type": "application/json; application/octet-stream" },
    metaValue: "下载",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// 海报二维码链接获取
export function getShareLink(params) {
  return request({
    url: "/customer/authToken/createShareLink",
    method: "post",
    params: params,
    metaValue: "获取海报链接"
  });
}

// 平台关键词搜索记录列表接口
export function getSearchKeyList(params) {
  return request({
    url: "/tools/getSearchKeyList",
    method: "get",
    params: params,
    metaValue: "平台关键词搜索记录列表获取"
  });
}

// 平台关键词搜索记录保存
export function saveSearchKey(params) {
  return request({
    url: "/tools/saveSearchKey",
    method: "post",
    params: params,
    metaValue: "平台关键词搜索记录列表保存"
  });
}

// 号码地市和运营商查询接口
export function getphonecity(params) {
  return request({
    url: "/tools/authToken/getphonecity",
    method: "get",
    params: params,
    metaValue: "号码地市和运营商查询接口"
  });
}

// 号码地市和运营商查询接口(不需要token)
export function getphonecityNew(params) {
  return request({
    url: "/tools/getphonecityNew",
    method: "get",
    params: params,
    metaValue: "号码地市和运营商查询接口"
  });
}

// 集团彩铃下单接口
export function addOrderList(params) {
  return request({
    url: "/order/authToken/addOrderList",
    method: "post",
    params: params,
    metaValue: "集团彩铃下单"
  });
}

// 上报欣能汇集团创建
export function postXnhCircleRing(params) {
  return request({
    url: "/xnh/authToken/postXnhCircleRing",
    method: "post",
    params: params,
    metaValue: "上报欣能汇集团创建"
  });
}

// 上报欣能汇400创建
export function postXnhfour(params) {
  return request({
    url: "/xnh/noToken/postXnhFourHundred",
    method: "post",
    params: params,
    metaValue: "上报欣能汇400创建"
  });
}

// 客户经理订单列表查询接口
export function getOrderList(params) {
  return request({
    url: "/order/authToken/queryOrderList",
    method: "post",
    params: params,
    metaValue: "客户经理订单列表查询"
  });
}

// 客户经理订单列表详情接口
export function getOrderListDetail(params) {
  return request({
    url: "/order/authToken/getOrderListDetails",
    method: "post",
    params: params,
    metaValue: "客户经理订单列表详情"
  });
}

// 模糊查询成员号码接口
export function queryOrderMobile(params) {
  return request({
    url: "/order/authToken/queryOrderMobile",
    method: "post",
    params: params,
    metaValue: "模糊查询成员号码"
  });
}

// 添加成员号码接口
export function addOrderMember(params) {
  return request({
    url: "/order/authToken/addOrderMember",
    method: "post",
    params: params,
    metaValue: "添加成员号码"
  });
}

// 添加成员上报同步欣能汇接口
export function postXnhAddMember(params) {
  return request({
    url: "/xnh/authToken/postXnhAddMember",
    method: "post",
    params: params,
    metaValue: "添加成员号码上报欣能汇"
  });
}

// 个人中心展示接口
export function getPersonalDetails(params) {
  return request({
    url: "/personal/authToken/getPersonalDetails",
    method: "post",
    params: params,
    metaValue: "个人中心展示接口"
  });
}

// 佣金列表接口
export function getCommissionList(params) {
  return request({
    url: "/personal/authToken/getCommissionList",
    method: "post",
    params: params,
    metaValue: "佣金列表接口"
  });
}

// 佣金详情接口
export function getCommissionDetail(params) {
  return request({
    url: "/personal/authToken/getCommissionDetails",
    method: "post",
    params: params,
    metaValue: "佣金详情接口"
  });
}

// 返佣规则接口
export function getProcommissionConfigList(params) {
  return request({
    url: "/personal/authToken/getProcommissionConfigList",
    method: "post",
    params: params,
    metaValue: "返佣规则"
  });
}

// 提现接口
export function forCash(params) {
  return request({
    url: "/money/authToken/postWithdrawal",
    method: "post",
    params: params,
    metaValue: "提现接口"
  });
}

// 我的队员列表接口
export function getParentMemberDetail(params) {
  return request({
    url: "/personal/authToken/getCustomerList",
    method: "post",
    params: params,
    metaValue: "我的队员列表"
  });
}

// 客户经理修改个人信息
export function updateManageInfo(params) {
  return request({
    url: "/customer/authToken/updateInfo",
    method: "post",
    params: params,
    metaValue: "客户经理修改个人信息"
  });
}

// 测试页面微信支付
export function wxpayForTest(params) {
  return request({
    url: "/wxauth/wxPay/native/jsapipay",
    method: "post",
    params: params,
    metaValue: "测试页面微信支付",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// 测试页面获取openid
export function getTestOpenId(params) {
  return request({
    url: "/wxauth/wxAuthSnsapi_base",
    method: "get",
    params: params,
    metaValue: "获取用户open-id",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// 首易信支付
export function sxyPayApi(params) {
  return request({
    url: "/syxthreepay/threePay",
    method: "post",
    params: params,
    metaValue: "首易信支付",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// 首易信支付取消
export function sxyPayApiCancel(params) {
  return request({
    url: "/syxthreepay/cancelPay",
    method: "post",
    params: params,
    metaValue: "首易信支付取消",
    onlyParams: true  // 只需传参 不需要加密
  });
}



// WEBPACK FOOTER //
// ./src/api/api/common.js